const apiUrl = process.env.REACT_APP_API_URL;

// Suspèn l'alumne per ús d'IA generativa: aplica una penalització OVERRIDE amb nota 0
// i el missatge automàtic del sistema (es_ia = 1). Reaprofita el mecanisme de penalitzacions.
export const SuspendrePerIA = async (id_practica: string, id_usuari: string) => {
    try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(
            `${apiUrl}:8061/jutge/practica/${id_practica}/usuaris/${id_usuari}/suspendre-ia`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });
        return response.ok;
    } catch (error) {
        console.log('Error suspenent per IA:', error);
        return false;
    }
};
